import React, { FC } from 'react';
import { Button } from 'antd';
import { Hamburger, Receipt } from 'common/svg';
import { priceFormatter } from 'common/helpers/format.helper';
import { IPurchaseOrderRecoStoreModel } from 'entities/PurchaseOrder/PurchaseOrder.models';
import { getShortStoreName } from 'entities/Store/Store.helper';

interface IComponentProps {
  item: IPurchaseOrderRecoStoreModel;
  onClick: (item: IPurchaseOrderRecoStoreModel) => void;
}

// MBC-85: Track PO RECO column card — store without active SO + RECO total.
// Click navigates to Generate PO with the store pre-selected (router state).
export const TrackPORecoCard: FC<IComponentProps> = ({ item, onClick }) => {
  const storeName = getShortStoreName(item.storeCode, item.storeName);

  return (
    <div className="kanban-board__card">
      <div className="kanban-board__card-header">
        <span className="ff-medium fs-xxs">{`RECO FOR ${item.storeCode}`}</span>
        <Button className="btn-secondary h-24" onClick={() => onClick(item)}>
          Order
        </Button>
      </div>

      <div className="kanban-board__card-body">
        <div className="kanban-board__card-body-row">
          <div className="kanban-board__card-body-row-label">
            <Hamburger className="icon-gray" />
            Store
          </div>
          <span className="kanban-board__card-body-row-value">{storeName}</span>
        </div>
        <div className="kanban-board__card-body-row">
          <div className="kanban-board__card-body-row-label">
            <Receipt className="icon-gray" />
            RECO Total
          </div>
          <span className="kanban-board__card-body-row-value">{priceFormatter(item.totalAmount)}</span>
        </div>
      </div>
    </div>
  );
};
